import { cleanString } from '@polleverywhere/core/lib/util'
import GraphQLModel from './graphQLModel'

export default class GraphQLTextResult extends GraphQLModel {
  poll () {
    const collectionPoll = this.collection ? this.collection.poll : null
    return this.options.poll || collectionPoll
  }

  /**
   * Getter for the result source.
   * @return {string}
   */
  get source () {
    return this.options.source || 'private_link'
  }

  /**
   * Update the result source.
   * @return {string}
   */
  set source (value) {
    this.options.source = value
  }

  /**
   * @param {Object} attrs
   * @param {Object} options
   * @param {Poll} options.poll Poll model that this result pertains to.
   * @param {Poll} options.source Human ID where result originated from.
   *    https://ci.ops.pe/browse/RA-REDOC/latest/artifact/JOB1/Site/ci.html#tag/Participant::Results
   */
  initialize (attrs, options = {}) {
    this.options = Object.assign({
      poll: null,
      source: null
    }, options)
  }

  /**
   * Seralized data to be sent to the respective endpoint on `save`,
   * @return {Object}
   */
  toJSON () {
    const json = this.attributes

    // Add source key if it exists.
    if (this.source) {
      json.source = this.source
    }

    return json
  }

  isApproved () {
    return this.get('approved') === true
  }

  isRejected () {
    return this.get('approved') === false
  }

  isUnmoderated () {
    return this.get('approved') === null
  }

  isDeleted () {
    return !!this.get('deleted_at')
  }

  cleanValue () {
    return cleanString(this.get('value'))
  }

  moderationState () {
    switch (this.get('approved')) {
      case true:
        return 'approved'
      case false:
        return 'rejected'
      default:
        return 'pending'
    }
  }

  shouldBeDisplayed () {
    if (this.isRejected() || this.isDeleted()) {
      return false
    }

    const poll = this.poll()
    const moderationEnabled = poll && poll.get('moderation_enabled')
    if (moderationEnabled && this.isUnmoderated()) {
      return false
    }

    return true
  }
}
